import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import PropTypes from 'prop-types'
import moment from 'moment'

import getByPath from 'lodash/get'

import { TextInput, TextEditor, TimePicker } from '../UI'
import PlacesAutocomplete from './PlacesAutocomplete'
import {NotificationManager} from 'react-notifications'

import { getPlaceInfoById } from './../../libs/utils'
import { defaultDate } from './index'

class Flight extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    onFormFieldChange: PropTypes.func.isRequired,
    dates: PropTypes.array,
    t: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      departure: '',
      departureAddress: '',
      departureDate: moment().startOf('day'),
      departureTime: moment().startOf('day'),
      arrival: '',
      arrivalAddress: '',
      arrivalDate: moment().startOf('day'),
      arrivalTime: moment().startOf('day'),
      type: 'Flight'
    }
  }

  onAirportSelect(place, placeId, type) {
    this.setState(
      {
        [type]: place
      },
      async () => {
        let placeInfo

        try {
          placeInfo = await getPlaceInfoById(placeId)
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }

        this.setState({
          [`${type}Address`]: placeInfo.formatted_address
        })
      }
    )

    this.props.onFormFieldChange(`eventDetails.flightDetails.${type}Airport`, {
      apiId: placeId,
      name: place,
      code: `${placeId}`
    })
  }

  checkStartDate(isDate) {
    if (isDate) {
      if (this.state.arrivalDate.isBefore(this.state.departureDate)) {
        this.setState(
          {
            arrivalDate: this.state.departureDate.clone().set({
              hours: this.state.arrivalTime.hours(),
              minutes: this.state.arrivalTime.minutes()
            })
          },
          () => {
            this.props.onFormFieldChange('endDate', this.state.arrivalDate.toISOString())
          }
        )
      }
    }

    const startDate = this.state.departureDate.clone().set({
      hours: this.state.departureTime.hours(),
      minutes: this.state.departureTime.minutes()
    })

    this.props.onFormFieldChange('startDate', startDate.toISOString())
  }

  checkEndDate() {
    const endDate = this.state.arrivalDate.clone().set({
      hours: this.state.arrivalTime.hours(),
      minutes: this.state.arrivalTime.minutes()
    })

    this.props.onFormFieldChange('endDate', endDate.toISOString())
  }

  render() {
    const { dates, onFormFieldChange, form, t } = this.props

    const departureInputProps = {
      value: this.state.departure,
      placeholder: t('location_placeholder'),
      onChange: departure => {
        this.setState({ departure })
      }
    }

    const arrivalInputProps = {
      value: this.state.arrival,
      placeholder: t('location_placeholder'),
      onChange: arrival => {
        this.setState({ arrival })
      }
    }

    return (
      <div id="flight-form" className="event__form--hidden">
        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('time')}</h2>

          <div className="form-group">
            <label htmlFor="departure-airport" className="event__form-label col-md-3 control-label">
              {t('departure_airport_label')}
            </label>
            <PlacesAutocomplete
              inputProps={departureInputProps}
              onSelect={(place, placeId) => {
                this.onAirportSelect(place, placeId, 'departure')
              }}
            />
          </div>

          {!!this.state.departureAddress && (
            <div className="form-group">
              <label htmlFor="activityPlaceAddress" className="event__form-label col-md-3 control-label" />
              <div className="col-md-9">
                <div className="formatted-address">{this.state.departureAddress}</div>
              </div>
            </div>
          )}

          <div className="mb-0 form-group">
            <label htmlFor="flightDepartureDateDay" className="event__form-label col-md-3 control-label">
              {t('date_day_label')}
            </label>
            <div className="col-md-4">
              <select
                id="flightDepartureDateDay"
                className="form-control event__form-input"
                value={this.state.departureDate && this.state.departureDate.toISOString()}
                onChange={e => {
                  this.setState(
                    {
                      departureDate: moment(e.target.value)
                    },
                    () => {
                      this.checkStartDate(true)
                    }
                  )
                }}
              >
                <option value="" disabled hidden>
                  {t('date_day_placeholder')}
                </option>
                {dates.map((day, i) => (
                  <option
                    key={i}
                    value={
                      day.dayOfTrip ||
                      defaultDate
                        .clone()
                        .add(i, 'days')
                        .toISOString()
                    }
                  >
                    {!!day.dayOfTrip ? `${moment(day.dayOfTrip).format('MMM D')} / ` : ''}
                    {day.title}
                  </option>
                ))}
              </select>
            </div>
            <TimePicker
              id="flightDepartureStartTime"
              value={this.state.departureTime && this.state.departureTime.toDate()}
              onChange={(id, departureTime) => {
                this.setState({ departureTime }, () => {
                  this.checkStartDate(true)
                })
              }}
              label={t('time')}
              labelClass="event__form-label col-md-4 control-label"
              extraClass="col-md-8"
            />
          </div>
          <div className="form-group">
            <label htmlFor="arrival-airport" className="event__form-label col-md-3 control-label">
              {t('arrival_airport_label')}
            </label>
            <PlacesAutocomplete
              inputProps={arrivalInputProps}
              onSelect={(arrival, id) => {
                this.setState({ arrival }, () => {
                  this.onAirportSelect(arrival, id, 'arrival')
                })
              }}
            />
          </div>

          {!!this.state.arrivalAddress && (
            <div className="form-group">
              <label htmlFor="activityPlaceAddress" className="event__form-label col-md-3 control-label" />
              <div className="col-md-9">
                <div className="formatted-address">{this.state.arrivalAddress}</div>
              </div>
            </div>
          )}

          <div className="mb-0 form-group">
            <label htmlFor="flightArrivalDateDay" className="event__form-label col-md-3 control-label">
              {t('date_day_label')}
            </label>
            <div className="col-md-4">
              <select
                id="flightArrivalDateDay"
                className="form-control event__form-input"
                value={this.state.arrivalDate && this.state.arrivalDate.toISOString()}
                onChange={e => {
                  this.setState(
                    {
                      arrivalDate: moment(e.target.value)
                    },
                    () => {
                      this.checkEndDate()
                    }
                  )
                }}
              >
                <option value="" disabled hidden>
                  {t('date_day_placeholder')}
                </option>
                {dates.map((day, i) => (
                  <option
                    key={i}
                    value={
                      day.dayOfTrip ||
                      defaultDate
                        .clone()
                        .add(i, 'days')
                        .toISOString()
                    }
                  >
                    {!!day.dayOfTrip && `${moment(day.dayOfTrip).format('MMM D')} / `}
                    {day.title}
                  </option>
                ))}
              </select>
            </div>
            <TimePicker
              id="flightArrivalStartTime"
              value={this.state.arrivalTime && this.state.arrivalTime.toDate()}
              onChange={(id, arrivalTime) => {
                this.setState({ arrivalTime }, () => {
                  this.checkEndDate()
                })
              }}
              label={t('time')}
              labelClass="event__form-label col-md-4 control-label"
              wrapperClass="mb-0"
              extraClass="col-md-8"
            />
          </div>
        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('description_label')}</h2>
          <div className="event__example-container">
            <i className="icon-flag event__example-icon" /> <span className="event__example-text">{t('description_example')}</span>
          </div>
          <TextEditor
              id="editor"
              value={form.description}
              placeholder={t('description_placeholder')}
              onChange={(content, delta, source, editor) => {
                onFormFieldChange('description', content)
              }}
          />
                  
        </div>

        <hr />

        <div className="form-horizontal event__form-container">
          <h2 className="event__form-group-label">{t('price')}</h2>
          <div className="form-group">
            <label htmlFor="activity-amount" className="event__form-label col-md-3 control-label">
              {t('amount_label')}
            </label>
            <div className="col-md-3">
              <input
                type="text"
                value={form.price}
                id="activity-amount"
                className="form-control event__form-input"
                placeholder={t('amount_placeholder')}
                onChange={e => (isNaN(+e.target.value) ? null : onFormFieldChange('price', +e.target.value))}
              />
            </div>
            <label htmlFor="flightCurrency" className="event__form-label col-md-2 control-label">
              {t('currency_label')}
            </label>
            <div className="col-md-3">
              <select
                id="flightCurrency"
                value={form.currency}
                className="form-control event__form-input"
                onChange={e => onFormFieldChange('currency', e.target.value)}
              >
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="NIS">NIS</option>
              </select>
            </div>
          </div>
          <div>
            <TextInput
              label={t('book_through_label')}
              labelClass="event__form-label col-md-3 control-label"
              type="text"
              isGroup={true}
              inputWrapperClass="col-md-6"
              id="eventDetails.bookedThrough"
              initialValue={getByPath(form, 'eventDetails.bookedThrough')}
              extraClass="form-control event__form-input"
              placeholder={t('book_through_placeholder')}
              onChangeExternal={(id, value) => onFormFieldChange(id, value)}
            />
          </div>
          <div>
            <TextInput
              label={t('confirmation_number_label')}
              labelClass="event__form-label col-md-3 control-label"
              type="text"
              isGroup={true}
              inputWrapperClass="col-md-6"
              id="eventDetails.confirmationCode"
              initialValue={getByPath(form, 'eventDetails.confirmationCode')}
              extraClass="form-control event__form-input"
              placeholder={t('confirmation_number_placeholder')}
              onChangeExternal={(id, value) => onFormFieldChange(id, value)}
            />
          </div>
          <div>
            <TextInput
              label={t('airline_label')}
              labelClass="event__form-label col-md-3 control-label"
              type="text"
              isGroup={true}
              inputWrapperClass="col-md-6"
              id="eventDetails.flightDetails.airline"
              initialValue={getByPath(form, 'eventDetails.flightDetails.airline')}
              extraClass="form-control event__form-input"
              placeholder={t('airline_placeholder')}
              onChangeExternal={(id, value) => onFormFieldChange(id, value)}
            />
          </div>
          <div>
            <TextInput
              label={t('flight_number_label')}
              labelClass="event__form-label col-md-3 control-label"
              type="text"
              isGroup={true}
              inputWrapperClass="col-md-6"
              id="eventDetails.flightDetails.flightNumber"
              initialValue={getByPath(form, 'eventDetails.flightDetails.flightNumber')}
              extraClass="form-control event__form-input"
              placeholder={t('flight_number_placeholder')}
              onChangeExternal={(id, value) => onFormFieldChange(id, value)}
            />
          </div>
          <div className="row">
            <div className="col-md-6">
              <TextInput
                label={t('terminal_label')}
                labelClass="event__form-label col-md-6 control-label"
                type="text"
                isGroup={true}
                inputWrapperClass="col-md-4"
                id="eventDetails.flightDetails.terminal"
                initialValue={getByPath(form, 'eventDetails.flightDetails.terminal')}
                extraClass="form-control event__form-input"
                placeholder="1"
                wrapperClass="mb-0"
                onChangeExternal={(id, value) => onFormFieldChange(id, value)}
              />
            </div>
            <div className="col-md-6">
              <TextInput
                label={t('gate_label')}
                labelClass="event__form-label col-md-6 control-label"
                type="text"
                isGroup={true}
                inputWrapperClass="col-md-4"
                id="eventDetails.flightDetails.gateNumber"
                initialValue={getByPath(form, 'eventDetails.flightDetails.gateNumber')}
                extraClass="form-control event__form-input"
                placeholder="1"
                wrapperClass="mb-0"
                onChangeExternal={(id, value) => onFormFieldChange(id, value)}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  translate('event', {
    withRef: true
  })
)(Flight)



// WEBPACK FOOTER //
// src/components/Event/Flight.js